// extracted by mini-css-extract-plugin
export var displayOptionsAsGrid = "CustomCheckBoxField-module__displayOptionsAsGrid___F4VFS";
export var displayOptionsAsRow = "CustomCheckBoxField-module__displayOptionsAsRow___OaTAv";
export var option = "CustomCheckBoxField-module__option___sD6zv";
export var optionMargin = "CustomCheckBoxField-module__optionMargin___TaLuD";
export var subtitle = "CustomCheckBoxField-module__subtitle___wH8l2";